@for (language of languages; track language; let i = $index) {
  <span
    (click)="changeLanguage(language.code)"
  [ngClass]="{
    'language-selected': language.code === selectedLanguage,
    'language-unselected': language.code !== selectedLanguage,
    'bordered': i < languages.length - 1
  }"
  >{{ language.display }}</span>
}